/* eslint id-length: "off" */
import PropTypes from "prop-types";
import MDMusicExternalLink from "@/components/music/md-player/MDMusicExternalLink";
import {albumLine} from "@/lib/music/format";

const MDMusicTrackInfo = ({size = "normal", track, withLink = true}) => {
  const titleClass = size === "compact" ? "title is-6 mb-1" : "title is-5 mb-1";
  const subtitleClass = size === "compact"
    ? "subtitle is-7 has-text-grey mb-0"
    : "subtitle is-6 has-text-grey mb-0";
  const album = albumLine(track);
  return (
    <div className="mdmusic-trackinfo">
      <p className={titleClass} title={track.trackName}>
        {track.trackName}
      </p>
      <p className={`is-italic ${subtitleClass}`} title={track.artistName}>
        by {track.artistName}
      </p>
      {album && (
        <p className="is-italic is-size-7 has-text-grey-light mb-1" title={album}>
          {album}
        </p>
      )}
      {withLink && <MDMusicExternalLink track={track}/>}
    </div>
  );
};

MDMusicTrackInfo.propTypes = {
  size: PropTypes.oneOf(["compact", "normal"]),
  track: PropTypes.shape({
    trackName: PropTypes.string.isRequired,
    artistName: PropTypes.string.isRequired,
    albumName: PropTypes.string,
    releaseYear: PropTypes.number,
    trackNumber: PropTypes.number,
    externalUrl: PropTypes.string,
    source: PropTypes.string.isRequired,
  }).isRequired,
  withLink: PropTypes.bool,
};

export default MDMusicTrackInfo;
